module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-test-d789a101eb2ebb1cc47b06b4e5a793f8.png";